import { ColumnDef } from "@tanstack/react-table";
import { Link } from "react-router-dom";

import { IconButton } from "ui/icon-button";

import { ClientAttributes } from "hooks/api/use-clients";

import { Route as AppRoute } from "utilities/app-routes";

import { BasicTableActionsProps } from "containers/admin/clients/client/approval-queue/approval-queue.types";

import Icons from "assets";

interface TableActionsProps extends BasicTableActionsProps {
  isEditEnabled: boolean;
}

const headerStyles = "text-gray-600 font-bold leading-5";

export const createClinetTableColumns = ({
  pathname,
  isEditEnabled,
}: TableActionsProps): ColumnDef<ClientAttributes>[] => [
  {
    id: "name",
    header: "Client name",
    accessorKey: "name",
    enableSorting: false,
    cell: ({ row }) => (
      <div className="flex items-center gap-3 pr-3">
        <Link
          to={`${pathname}/${row.original.id}/${AppRoute.campaigns}`}
          className="text-aqua-600 hover:text-aqua-700 font-semibold text-base"
          aria-disabled={false}
          tabIndex={undefined}>
          {row.original.name}
        </Link>
      </div>
    ),
    size: 940,
    meta: {
      headerClassName: `${headerStyles} pl-4`,
    },
  },
  {
    id: "actions",
    header: "Actions",
    enableSorting: false,
    cell: ({ row }) => (
      <div className="flex items-center justify-center gap-1">
        <IconButton
          variant="text"
          to={`${pathname}/${row.original.id}/${AppRoute.campaigns}`}
          aria-label="View client"
          data-testid="view-client-button"
          size="medium">
          <Icons.EyeVisible />
        </IconButton>

        {isEditEnabled && (
          <IconButton
            variant="text"
            to={`${pathname}/${row.original.id}/${AppRoute.profile}/edit`}
            aria-label="Edit client"
            size="medium">
            <Icons.Edit />
          </IconButton>
        )}
      </div>
    ),
    size: 76,
    meta: {
      className: "pr-8",
      headerClassName: headerStyles,
      isHeaderCentered: true,
      isPinnedRight: true,
    },
  },
];
